import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import { API } from "./lib/api";
import { LanguageProvider } from "./lib/LanguageContext";

import LoginScreen from "./components/app/LoginScreen";
import AgeVerification from "./components/app/AgeVerification";
import LandingPage from "./components/app/LandingPage";
import Dashboard from "./components/app/Dashboard";
import ModelForm from "./components/app/ModelForm";
import ModelDetail from "./components/app/ModelDetail";

function App() {
  const [authToken, setAuthToken] = useState(() => localStorage.getItem('authToken'));
  const [authValid, setAuthValid] = useState(false);
  const [authChecking, setAuthChecking] = useState(true);
  const [ageVerified, setAgeVerified] = useState(() => {
    return localStorage.getItem('ageVerified') === 'true';
  });

  useEffect(() => {
    if (authToken) {
      axios.get(`${API}/auth/verify?token=${authToken}`)
        .then(() => { setAuthValid(true); setAuthChecking(false); })
        .catch(() => { localStorage.removeItem('authToken'); setAuthToken(null); setAuthValid(false); setAuthChecking(false); });
    } else {
      setAuthChecking(false);
    }
  }, [authToken]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleLogin = (token) => {
    setAuthToken(token);
    setAuthValid(true);
  };

  const handleAgeVerify = () => {
    localStorage.setItem('ageVerified', 'true');
    setAgeVerified(true);
  };

  if (authChecking) {
    return (
      <div className="fixed inset-0 bg-background flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-primary animate-spin" />
      </div>
    );
  }

  return (
    <LanguageProvider>
      <div className="App">
        <Toaster position="top-right" theme="dark" richColors />

        {!authValid && <LoginScreen onLogin={handleLogin} />}
        {authValid && !ageVerified && <AgeVerification onVerify={handleAgeVerify} />}

        {authValid && (
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/models/new" element={<ModelForm />} />
              <Route path="/models/:id" element={<ModelDetail />} />
              <Route path="/models/:id/edit" element={<ModelForm isEdit />} />
            </Routes>
          </BrowserRouter>
        )}
      </div>
    </LanguageProvider>
  );
}

export default App;
